import { Fragment } from 'react';
import Breadcrumbs from 'shell/components/shared/breadcrumb';
import PersonSearch from 'shell/components/shared/person-search';
import ActionsList from 'mutation/components/registration-civil-union/resident/actions-list';
import { SearchPersonCivilUnionCrumbs } from 'mutation/constants/registration-civil-union-crumbs';

const PersonsPageCivilUnion = (): React.ReactElement => {
  return (
    <Fragment>
      <Breadcrumbs items={SearchPersonCivilUnionCrumbs} />
      <PersonSearch
        pathname="/mutazioni/persona/unione-civile/residenti/registrazione"
        action={ActionsList}
        addedTitle={'- Registrazione Unione Civile'}
      />
    </Fragment>
  );
};

PersonsPageCivilUnion.displayName = 'Persons page component';

export default PersonsPageCivilUnion;
